import { AddressDto, EntityDtoBase, IdNameDto } from './Common'
import { ContactDto } from './Contact'
import { NotificationDto } from './Notification'
import { EventBriefDto } from './Event'
import { EmailMessageType, EventRepetitionReminderMode } from './Email'

export enum ClientType {
    NotSet = 0,
    Citizen = 1,
    LegalEntity = 2,
    Individual = 3,
}

export interface ClientDto extends EntityDtoBase {
    clientType: ClientType
    companyRegistrationNumber: string
    valueAddedTaxIdentificationNumber: string
    name: string
    note: string
    address: AddressDto
    contacts: ContactDto[]
    events: EventBriefDto[]
    notifications: NotificationDto[]
    // Partial: the server omits RemindEventRepetition, it is driven by eventRepetitionReminderMode
    emailMessageSwitches: Partial<Record<EmailMessageType, boolean>>
    eventRepetitionReminderMode: EventRepetitionReminderMode
}

export interface CreateClientDto extends Omit<ClientDto, 'id' | 'createdAt' | 'events'> {}

export interface ClientBriefDto extends Omit<ClientDto, 'events' | 'notifications'> {
    contactCount: number
    eventCount: number
    notificationCount: number
    /**
     * Sum of all (filtered) related events profit
     */
    profit: number
}
export interface ClientLookupDto extends IdNameDto {
    contacts: ContactDto[]
}

export interface ClientUniquenessDto {
    isUnique: boolean
    conflictedProperties: string[]
}
